import moment from 'moment';

moment.locale('nl');
